/**
 * 表单数据转JSON字符串的通用hook
 * 过滤掉值为null或undefined的字段
 */
import { FormInstance } from 'antd';

/**
 * 将表单数据转换为JSON字符串
 * @param values 表单数据对象
 * @returns JSON字符串，如果所有值都为null/undefined则返回null
 */
export const filterFormValues = (values: any): string | null => {
  // 递归过滤对象中的null和undefined值
  const filterObject = (obj: any): any => {
    if (obj === null || obj === undefined) {
      return undefined;
    }

    if (typeof obj !== 'object' || obj instanceof Date) {
      return obj;
    }

    if (Array.isArray(obj)) {
      const filtered = obj.map(item => filterObject(item)).filter(item => item !== undefined);
      return filtered.length > 0 ? filtered : undefined;
    }

    const filtered: any = {};
    let hasValidValue = false;

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const value = filterObject(obj[key]);
        if (value !== undefined && value !== null) {
          filtered[key] = value;
          hasValidValue = true;
        }
      }
    }

    return hasValidValue ? filtered : undefined;
  };

  const filteredValues = filterObject(values);

  // 如果过滤后没有有效值，返回null
  if (!filteredValues || Object.keys(filteredValues).length === 0) {
    return null;
  }

  return JSON.stringify(filteredValues);
};

/**
 * 从表单实例获取JSON字符串的hook
 * @param form Antd表单实例
 * @returns 返回一个异步函数，用于获取表单的JSON字符串
 */
export const useFormToJsonString = (form: FormInstance) => {
  const getSubmitString = async (): Promise<string | null> => {
    const values = await form.validateFields();
    return filterFormValues(values);
  };

  return { getSubmitString };
};
